import { Box, Flex, FlexProps, Text } from '@chakra-ui/react';
import { BooleanTraitType } from '@cyberkongz/api-interfaces';

import { Badge, CloseIcon } from '../../../components';
import { pxToRem } from '../../../theme';
import { GENKAI_FILTERS_VALUE_LABELS } from '../consts';
import { useKollections } from '../KollectionsProvider';

function KollectionsFiltersPill({ onClick, children, ...rest }: FlexProps) {
  return (
    <Badge
      textStyle="none"
      onClick={onClick}
      bg="neutral.700"
      borderColor="neutral.700"
      fontSize="xs"
      {...rest}
    >
      <Flex alignItems="center" gap={1}>
        <Box>{children}</Box>
        <CloseIcon boxSize={pxToRem(14)} />
      </Flex>
    </Badge>
  );
}

export function KollectionsFiltersPills({
  styles,
}: {
  styles?: { pill?: FlexProps; clearPill?: FlexProps };
}) {
  const {
    clearFilters,
    stringTraits,
    setStringTrait,
    booleanTraits,
    setBooleanTrait,
    genkaiFilters,
    setGenkaiFilter,
  } = useKollections();
  const booleanTraitsFiltered = Object.entries(booleanTraits).reduce<BooleanTraitType[]>(
    (booleanTraitsArray, booleanTrait) => {
      if (booleanTrait[1]) {
        booleanTraitsArray.push(booleanTrait[0] as BooleanTraitType);
      }

      return booleanTraitsArray;
    },
    [] as BooleanTraitType[]
  );

  const genkaiFiltersFiltered = Object.entries(genkaiFilters).reduce(
    (genkaiFiltersArray, genkaiFilter) => {
      const [filter, value] = genkaiFilter;
      if (value) {
        genkaiFiltersArray.push({ filter: filter as keyof typeof genkaiFilters, value });
      }

      return genkaiFiltersArray;
    },
    // to do better typing
    [] as { filter: keyof typeof genkaiFilters; value: any }[]
  );

  return stringTraits.length > 0 ||
    booleanTraitsFiltered.length > 0 ||
    genkaiFiltersFiltered.length ? (
    <Flex flexWrap="wrap" gap={2} display={['none', null, 'flex']}>
      <Badge
        onClick={clearFilters}
        textStyle="none"
        fontWeight="medium"
        bg="text"
        color="background"
        fontSize="xs"
        {...styles?.clearPill}
      >
        Clear All
      </Badge>
      {genkaiFiltersFiltered.map(({ filter, value }) => (
        <KollectionsFiltersPill
          key={filter}
          onClick={() => setGenkaiFilter({ filter, value: undefined })}
          {...styles?.pill}
        >
          <Text as="span" textTransform="capitalize">
            {filter}:{` `}
          </Text>
          {/* @ts-ignore */}
          {GENKAI_FILTERS_VALUE_LABELS[value]}
        </KollectionsFiltersPill>
      ))}
      {booleanTraitsFiltered.map((traitType) => (
        <KollectionsFiltersPill
          key={`${traitType}`}
          onClick={() => setBooleanTrait(traitType)}
          {...styles?.pill}
        >
          {traitType.toUpperCase()}
        </KollectionsFiltersPill>
      ))}
      {stringTraits.map(({ traitType, values }) =>
        values.map((value) => (
          <KollectionsFiltersPill
            key={`${traitType}-${value}`}
            onClick={() => setStringTrait({ traitType, value })}
            {...styles?.pill}
          >
            {`${traitType}: ${value}`}
          </KollectionsFiltersPill>
        ))
      )}
    </Flex>
  ) : null;
}
